import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import TableLoader from "../../../../../common/tableLoader";
import Toast from "../../../../../common/toast";

// Add legend component
const JobStatusLegend = () => {
  const statuses = [
    { status: "Open", color: "#28a745" },
    { status: "Scheduled", color: "#17a2b8" },
    { status: "In Progress", color: "#ffc107" },
    { status: "Accepted", color: "#007bff" },
    { status: "Applied", color: "#6c757d" },
    { status: "Completed", color: "#20c997" },
    { status: "Cancelled", color: "#dc3545" },
    { status: "Closed", color: "#795548" },
  ];

  return (
    <div style={{ display: "flex", gap: "15px", marginBottom: "10px" }}>
      {statuses.map(({ status, color }) => (
        <div key={status} style={{ display: "flex", alignItems: "center" }}>
          <span
            style={{
              backgroundColor: color,
              width: "15px",
              height: "15px",
              borderRadius: "50%",
              display: "inline-block",
              marginRight: "5px",
            }}
          ></span>
          <span>{status}</span>
        </div>
      ))}
    </div>
  );
};

function CanJobsCalendarList({ isLoading, jobListData, setQueryParams }) {
  moment.locale("en-GB");
  const localizer = momentLocalizer(moment);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentView, setCurrentView] = useState(Views.MONTH);
  const navigate = useNavigate();

  const navigateToJobDetails = (item) => {
    navigate(`/job-detail/${item.id}`, { state: item });
  };

  const events = jobListData?.map((job) => {
    return {
      title: job?.jobTitle,
      start: moment.utc(job?.startTime).local().toDate(),
      end: moment.utc(job?.endTime).local().toDate(),
      jobStatus: job?.jobStatus,
      ...job,
    };
  });

  const eventStyleGetter = (event) => {
    let backgroundColor;

    switch (event?.jobStatus) {
      case "eOpen":
        backgroundColor = "#28a745"; // Green for open status
        break;
      case "scheduled":
        backgroundColor = "#17a2b8"; // Light blue for scheduled
        break;
      case "eInProgress":
        backgroundColor = "#ffc107"; // Yellow for in-progress
        break;
      case "eAccepted":
        backgroundColor = "#007bff"; // Blue for accepted
        break;
      case "eApplied":
        backgroundColor = "#6c757d"; // Gray for applied
        break;
      case "eCompleted":
        backgroundColor = "#20C997"; // Green for completed
        break;
      case "eCancelled":
        backgroundColor = "#dc3545"; // Red for cancelled
        break;
      case "eClosed":
        backgroundColor = "#795548"; //(Muted Gray)
        break;
      default:
        backgroundColor = "#6c757d"; // Gray for unknown status
    }

    return {
      style: {
        backgroundColor,
        color: "white",
        borderRadius: "5px",
        border: "0px",
      },
    };
  };

  const handleNavigate = (date, view) => {
    setCurrentDate(date);
    const selectedView = view || currentView;
    const formatDate = moment(date);

    let queryParams = "";

    if (selectedView === Views.MONTH) {
      queryParams = `&month=${formatDate.format("YYYY-MM")}`;
    } else if (selectedView === Views.WEEK) {
      const startOfWeek = formatDate.clone().startOf("week").startOf("day");
      const endOfWeek = formatDate.clone().endOf("week").endOf("day");
      queryParams = `&weekFromDate=${startOfWeek.toISOString()}&weekToDate=${endOfWeek.toISOString()}`;
    } else if (selectedView === Views.DAY) {
      queryParams = `&day=${formatDate.startOf("day").toISOString()}`;
    }

    setQueryParams(queryParams);
  };

  const handleViewChange = (view) => {
    setCurrentView(view);
    handleNavigate(currentDate, view);
  };

  return (
    <>
      <div className="mt-3 mb-3">
        <JobStatusLegend />
      </div>
      <div style={{ height: 550 }}>
        {!isLoading ? (
          <Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            style={{ height: 500 }}
            views={[Views.MONTH, Views.WEEK, Views.DAY]}
            defaultView={Views.MONTH}
            view={currentView}
            date={currentDate}
            onSelectEvent={(event) => navigateToJobDetails(event)}
            onNavigate={handleNavigate}
            onView={handleViewChange}
            step={15}
            popup={false}
            eventPropGetter={eventStyleGetter} // Apply the custom styles
          />
        ) : (
          <TableLoader />
        )}
      </div>

    </>
  );
}

export default CanJobsCalendarList;
